import React from 'react';
import { View, Text, TouchableOpacity, ImageStyle, ViewStyle, TextStyle } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { AvatarCircle } from '@/components/common/AvatarCircle';

type Props = {
  title: string;
  displayName: string;
  unitLabel?: string;
  photoUrl?: string | null;
  onPressSettings: () => void;
  styles: {
    headerView: ViewStyle;
    headerTopRow: ViewStyle;
    headerTitle: TextStyle;
    settingsButton: ViewStyle;
    profileRow: ViewStyle;
    profileTextCol: ViewStyle;
    nameLabel: TextStyle;
    addressLabel: TextStyle;
    avatarContainer: ViewStyle;
  };
};

export const ProfileHeader: React.FC<Props> = ({ title, displayName, unitLabel, photoUrl, onPressSettings, styles }) => {
  return (
    <View style={styles.headerView}>
      <View style={styles.headerTopRow}>
        <Text style={styles.headerTitle}>{title}</Text>
        <TouchableOpacity style={styles.settingsButton} onPress={onPressSettings}>
          <RESIDENTS_SVG_COMPONENTS.COG width={18} height={18} />
        </TouchableOpacity>
      </View>
      <View style={styles.profileRow}>
        <View style={styles.profileTextCol}>
          <Text style={styles.nameLabel} numberOfLines={1}>{displayName}</Text>
          {!!unitLabel && (<Text style={styles.addressLabel} numberOfLines={1}>{unitLabel}</Text>)}
        </View>
        <View style={styles.avatarContainer}>
          <AvatarCircle
            firstName={displayName.split(' ')[0] || ''}
            lastName={displayName.split(' ').slice(1).join(' ') || ''}
            size={62}
            photoUrl={photoUrl || undefined}
            useHashedColor={false}
            placeholderColor={'#D1D1D6'}
            imageBackgroundColor={'#D1D1D6'}
          />
        </View>
      </View>
    </View>
  );
};

export default ProfileHeader;


